<template>
    <section class="confirm" v-if="required_email !== null || required_phone !== null">
        <div class="box">
            <div class="b-1">
                <img :src="logo_url" alt="logo">
            </div>
            <div class="b-2">
                <div v-if="required_email" style="margin-bottom: 100px;">
                    <h2>Confirme seu e-mail</h2>
                    <p>Enviamos um e-mail de confirmação para {{email}} com o endereço de
                        verificação.</p>
                    <v-form ref="form">
                        <v-alert style="width: 350px" type="error" color="#e72c1f" v-if="errorConfirm !== null">
                            {{errorConfirm}}
                        </v-alert>
                        <v-btn :loading="loading" class="btn-blue mt-3" @click.prevent="reSendEmail()">
                            Enviar Novamente
                        </v-btn>
                    </v-form>
                </div>
            </div>
        </div>
        <v-snackbar
                v-model="message_success"
                :color="'success'"
                :multi-line="true"
                :right="true"
                :timeout="8000"
                :top="true"
                class="snackbar-success"
        >
            <span><i class="fas fa-check mr-2"></i> Confirmação enviada com sucesso!</span>
        </v-snackbar>
    </section>
</template>

<script>
    export default {
        name: "ConfirmRegister",
        data:function () {
            return{
                loading:false,
                message_success:false,
                errorConfirm:null,
                email:null,
                phone:null,
                code: '',
                required_email:null,
                required_phone:null,
                rules: {
                    code: [
                        value => (value || '').length > 0 || 'O código é obrigatório',
                    ],
                }
            }
        },
        methods:{
            sendCode:function () {
                this.loading = true;
                axios.post('/api/signup/activate/phone/'+this.code).then(res => {
                    if(res.data === true){
                        location.reload();
                    }else{
                        this.errorConfirm = "Código inválido."
                    }
                })
                .catch(() =>{
                    this.errorConfirm = "Ocorreu um erro. Tente novamente."
                }).finally(()=>{
                    this.loading = false;
                })
            },
            reSendCode:function () {
                this.message_success = false;
                this.loading = true;
                axios.get('/api/signup/resubmit/phone').then(res => {
                    this.message_success = true;
                }).catch(() => {
                    this.errorConfirm = "Ocorreu um erro. Tente novamente."
                }).finally(() => {
                    this.loading = false;
                })
            },
            reSendEmail:function () {
                this.message_success = false;
                this.loading = true;
                axios.get('/api/signup/resubmit/token').then(res => {
                    this.message_success = true;
                }).catch(()=> {
                    this.errorConfirm = "Ocorreu um erro. Tente novamente."
                }).finally(() => {
                    this.loading = false;
                })
            }
        },
        mounted() {
            axios.get('/api/user').then(res => {
                this.email = res.data.email;
                this.phone = res.data.phone;
                if(res.data.sms_verification_status === false && res.data.phone !== null){
                    this.required_phone = true;
                }
                if(res.data.active_mail === false && res.data.email !== null){
                    this.required_email = true;
                }
            });
        },
        computed: {
            logo_url: function () {
                return require('@/assets/imgs/logos/' + process.env.VUE_APP_HIGH_CONTRAST_LOGO_NAME);
            }
        }
    }
</script>

<style scoped>
    .input{
        width: 350px;
    }
    .confirm{
        width: 100%;
        min-height: 100vh;
        background-size: cover;
        background-image: url("../../assets/imgs/teste02.png");
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .box{
        width: 80%;
        height: 200px;
        display: flex;
        justify-content: flex-end;
        align-items: center;
    }
    .b-1{
        padding: 15px;
        width: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .b-2{
        text-align: left;
        width: 50%;
        padding: 0 0 0 15px;
    }
    h2{
        color: #595959;
        font-size: 24px;
        font-family: Roboto-Black;
        color: #595959;
        width: 400px;
    }
    p{
        font-family: Roboto-Light;
        font-size: 14px;
        width: 400px;
    }
    .btn-blue{
        text-transform: capitalize !important;
        background: #000 !important;
        color: #ffffff !important;
        font-family: Roboto-Black !important;
        height: 43px !important;
        border-radius: 4px !important;
        padding: 8px 15px !important;
        border: 3px solid #000 !important;
    }
    .btn-blue:hover{
        background: transparent !important;
        color: #000 !important;
    }
    .btn-red{
        background: transparent;
        font-family: Roboto-Black;
        width: 114px;
        height: 43px;
        border-radius: 4px;
        padding: 8px 15px;
        border: 3px solid #000;
        color: #000;
    }
    .btn-red:hover{
        background: #000;
        color: #ffffff;
    }

    .btn-red,.btn-blue{
        width: 350px;
    }

    @media only screen and (max-width: 500px) {
        .confirm{
            height: 100vh;
            text-align: center;
        }
        .box{
            display: block;
            width: 100%;
            height: auto;
            text-align: center;
        }

        .b-1{
            padding: 0;
            display: block;
            width: 100%;
        }

        .b-2{
            padding: 15px;
        }

        .b-1 img{
            margin: 0 auto;
        }

        h2{
            text-align: center;
        }


        h2,p,.b-2,.btn-blue,.btn-red{
            width: 100%;
        }

        .btn-red,.btn-blue,.input{
            width: 100%;
        }

    }
</style>
